import { Stack, Typography } from '@mui/material';
import emptyFolderPageImage from 'assets/images/svg/empty-folder-page-icon.svg';
import useContentQueryManager from 'hooks/useContentQueryParams';
import { FolderLocation } from 'models/types';

const NO_RESULTS_FOUND = 'no results found';
const MOVE_AUDIENCES_HERE = 'move audiences here';
const NO_FILES_FOUND_HERE = 'no files found here';
const MOVE_FILES_OR_FOLDERS_HERE = 'move files or folders here';
const ADJUST_FILTERS_OR_LOOK_IN_A_DIFFERENT_FOLDER = 'adjust your filters or look in a different folder';
const OR_USE_CREATE_BUTTON = 'or use "Create" button';

export type Props = {
    folderLocation?: FolderLocation;
    hasActiveFilters?: boolean;
    searchTerm?: string;
    noResultsFoundText?: string;
    noResultsFoundSubtitle?: string;
};

const TableEmptyState = ({
    folderLocation,
    hasActiveFilters,
    searchTerm,
    noResultsFoundText,
    noResultsFoundSubtitle,
}: Props) => {
    const { type: contentType } = useContentQueryManager();

    const getHeaderText = () => {
        if (searchTerm || hasActiveFilters) {
            return noResultsFoundText || NO_RESULTS_FOUND;
        }
        if (folderLocation === FolderLocation.AUDIENCE_FOLDER) {
            return MOVE_AUDIENCES_HERE;
        }
        return folderLocation === FolderLocation.CONTENT_FOLDER && !!contentType
            ? NO_FILES_FOUND_HERE
            : MOVE_FILES_OR_FOLDERS_HERE;
    };

    const headerText = getHeaderText();

    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            role="status"
            aria-label={headerText}
            data-testid="table-empty-state"
            sx={{
                width: '100%',
                minHeight: 350,
                boxSizing: 'border-box',
                backgroundImage: `url(${emptyFolderPageImage})`,
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                height: '80%',
            }}
        >
            <Typography fontSize="24px" fontWeight="500" data-testid="table-empty-state-header">
                {headerText}
            </Typography>
            <Typography
                variant="body2"
                maxWidth="270px"
                textAlign="center"
                pt={1}
                data-testid="table-empty-state-subtitle"
            >
                {searchTerm || hasActiveFilters
                    ? noResultsFoundSubtitle || ''
                    : !!contentType
                    ? ADJUST_FILTERS_OR_LOOK_IN_A_DIFFERENT_FOLDER
                    : OR_USE_CREATE_BUTTON}
            </Typography>
        </Stack>
    );
};

export default TableEmptyState;
